(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Cycle order, per spec: auto -> forced day -> forced night -> back
  // to auto. Keyed off data-mode-preference (layout/theme.liquid),
  // never off data-mode itself -- data-mode is always a resolved
  // concrete value (daytime/nighttime) even while the preference is
  // 'auto', so it can't tell us where in the three-state cycle we are.
  var NEXT_PREFERENCE = {
    auto: 'daytime',
    daytime: 'nighttime',
    nighttime: 'auto'
  };

  // Describes the CURRENT preference (not "switch to X" like the old
  // two-state version) -- matches spec's exact three strings, and
  // reads more clearly for a three-position cycle than a "next state"
  // phrasing would ("Auto" as a label while active is less ambiguous
  // than trying to describe what daytime/nighttime/auto cycles to
  // next from an already-three-way state).
  function labelFor(preference) {
    if (preference === 'nighttime') { return 'Nighttime'; }
    if (preference === 'daytime') { return 'Daytime'; }
    return 'Auto (follows Stockholm time)';
  }

  function updateToggleLabel(toggle) {
    var current = document.documentElement.getAttribute('data-mode-preference');
    var label = labelFor(current);
    toggle.setAttribute('aria-label', label);
    toggle.setAttribute('title', label);
  }

  // Re-derives whatever sunset/sunrise reading is already cached, same
  // as assets/header-weather.js's own cachedSunset()/cachedSunrise()
  // -- duplicated here rather than exported from that file since this
  // is the one other place that needs it (immediately resuming real
  // time/weather-driven mode and twilight the instant a visitor
  // cycles back to auto, rather than waiting on that file's own 60s
  // re-check).
  function readWeatherCache() {
    var raw = null;
    try { raw = localStorage.getItem(window.EvaTheme.WEATHER_STORAGE_KEY); } catch (e) {}
    if (!raw) { return null; }
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function cachedSunset() {
    var cache = readWeatherCache();
    return cache && typeof cache.sunset === 'number' ? cache.sunset : null;
  }

  function cachedSunrise() {
    var cache = readWeatherCache();
    return cache && typeof cache.sunrise === 'number' ? cache.sunrise : null;
  }

  ready(function () {
    if (!window.EvaTheme) { return; }

    var toggles = document.querySelectorAll('[data-mode-toggle]');
    toggles.forEach(function (toggle) {
      updateToggleLabel(toggle);

      toggle.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-mode-preference') || 'auto';
        var next = NEXT_PREFERENCE[current] || 'auto';

        window.EvaTheme.applyModePreference(next, cachedSunset(), cachedSunrise());
        try {
          localStorage.setItem(window.EvaTheme.STORAGE_KEY, next);
        } catch (e) {}

        if (next === 'auto') {
          // Resume twilight immediately (per spec) rather than waiting
          // on assets/header-weather.js's next 60s re-check -- same
          // applyPeriod helper that file's own load/re-check path uses.
          window.EvaTheme.applyPeriod(cachedSunset());
        } else {
          // Forced daytime/nighttime skips twilight entirely, same as
          // before.
          document.documentElement.removeAttribute('data-period');
        }

        updateToggleLabel(toggle);
      });
    });
  });
})();
